import { Pipe, PipeTransform } from '@angular/core';

/**
 * Computes the CSS class for the due date pill (overdue/today highlighting).
 *
 * Replaces `DataGridComponent.getDueDateClass()`, moving the logic into a pure
 * pipe so Angular can memoize the result per input and avoid re-evaluating the
 * template function call on every change detection cycle.
 */
@Pipe({ name: 'dueDateClass', pure: true, standalone: false })
export class DueDateClassPipe implements PipeTransform {
  transform(dueDate: string | Date, status?: string): string {
    if (!dueDate) return '';

    // Don't apply color coding if task is closed or not applicable
    if (status) {
      const normalizedStatus = status.toLowerCase();
      if (normalizedStatus === 'closed' || normalizedStatus === 'not applicable' || normalizedStatus === 'n/a') {
        return '';
      }
    }

    const dt = new Date(dueDate);
    const today = new Date();

    // Set both to start of day for accurate comparison
    dt.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    // Check if overdue (past due date)
    if (dt < today) {
      return 'due-date-overdue';
    }

    // Check if due today
    if (dt.getTime() === today.getTime()) {
      return 'due-date-today';
    }

    // Future date - no special styling
    return '';
  }
}
